export default "__VITE_ASSET__CPBuvEmr__"